export default {
  payWelfareText: 'Benefit Top Up',
  blackFridayDiscount: 'Diskon Terbatas Black Friday',
  shareGift: 'Hadiah Share',
  vipWeeklyWelfare: 'Diskon Mingguan VIP',
  exchangeCoupon: 'Kupon Exchange',
  firstPayOff: 'Pembelian pertama kali bisa menikmati max 15%OFF',
  blackFridayEvent: 'Event Black Friday',
  limitedTimeOff: 'Diskon Terbatas 10% OFF',
  claimCoupon: 'Klaim Sekarang',
  blackFridayTimedCoupon:
    'Diskon Terbatas Black Friday -> Diskon Terbatas Black Friday',
  timeLeft: 'Sisa Event:',
  claimTimeCoupon: 'Klaim Terbatas Kupon 10% OFF',
  points: 'Sisa Poin: ${point}',
  costPointTip: 'Konsumsi poin untuk klaim Kupon tahap apa pun',
  maxPointTip: 'Setiap akun hanya bisa pakai max 500 poin',
  discountOff: '10% OFF',
  highestDiscount: 'Max Diskon: ${discount} ',
  needPoint: 'Perlu poin ${point}',
  changeCurrency: 'Ganti Mata Uang',
  claim: 'Klaim',
  claimSucc: 'Berhasil klaim',
  claimFail: 'Gagal klaim',
  pointNotEnough: 'Kekurangan poin',
  afterClaimPoint: 'Poin setelah klaim: ${point}',
  footTips1: '1 Kupon hanya untuk 1 pesanan',
  footTips2: 'Tidak mendukung Kupon ini saat beli Voucer',
  footTips3: 'Hak interpretasi akhir adalah milik tim operasional game.',
  ruleTitleText: 'Aturan Event',
  ruleTime: 'Waktu Event: 24/11/2023 00:00 ~ 26/11/2023 23:59 (UTC)',
  bfRuleText1:
    '1. Selama Event, akun yang login ke halaman Top Up offcial untuk pertama kalinya akan mendapat 400 poin, bisa digunakan untuk menukar Kupon, max bisa gunakan 500 poin.',
  bfRuleText2:
    '2. Selama Event, gunakan poin Black Friday bisa tukar Kupon dengan kuota berapa pun. Semakin tinggi kuota diskon, semakin banyak poin yang diperlukan. Setelah berhasil, akan mengurangi poin relevan.',
  bfRuleText3:
    '3. Setiap nomor pesanan hanya bisa menggunakan 1 Kupon. Item Voucer tidak mendukung Kupon Black Friday.',
  bfRuleText4: '4. Kopun Blac Friday hanya mendukung mata uang berikut:',
  ableCoinsType: 'USD,JPY,KRW,TWD,EUR,HKD,GBP,CAD,AUD,RUB,MYR,THB,PLN,IDR',
  bfRuleText5:
    '5. Setelah berhasil, tidak bisa ganti mata uang, juga tidak mendukung pengembalian poin. Silakan perhatikan kuota diskon dan konsumsi poin.',
  bfRuleText6:
    '6. Masa berlaku Kupon Black Friday hanya 7 hari. Harap digunakan dengan cermat.',
  bfRuleText7: '7. Hak interpretasi akhir adalah milik tim operasional game.',
  thanksTip:
    'Terima kasih atas partisipasi Anda, silakan follow komunistas official untuk event lainnya',
  exchangePoints: 'Kupon Exchange -> Tukar Poin',
  exchangeCode:
    'Silakan masukkan Redeem code setelah pilih metode pembayaran -> Masukkan Redeem code',
  enterExchangeCode:
    'Masukkan Redeem code di sini -> Silakan masukkan Redeem code',
  exchangeText: 'Tukar',
  confirmGet: 'Konfirmasi',
  couponUsedWay:
    'Kupon hanya bisa digunakan di metode pembayaran dengan mata uang yang ditentukan. Harap konfirmasi mata uang pembayaran yang ingin Anda gunakan.',
  confirmText: 'Konfirmasi',
  exchangeSucc: 'Berhasil',
  aboutCoins: 'Mengenai Voucer',
  aboutCoinsText:
    'Voucher bisa tukar semua paket hadiah dan layanan nilai tambah dalam game ini kecuali voucher',
  known: 'Mengerti',
  codeText: 'Redeem code',
  codeInvalid: 'Gagal redeem!',
  hasExchanged: 'Anda sudah tukar, hanya bisa klaim Redeem code sebanyak 1x!',
  hideText: 'Sembunyikan',
  //黑五的报错码
  'bf-20001': 'Belum Login',
  'bf-20002': 'Parameter salah. Silakan coba lagi masuk Event',
  'bf-20003': 'Kekurangan poin',
  'bf-20004': 'Gagal klaim. Silakan coba lagi nanti atau hubungi CS',
  'bf-20005': 'Sudah klaim',
  'bf-20015': 'Event tidak tersedia. Silakan nantikan',
  'bf-20016': 'Event Berakhir',
  bfShareText: 'Klaim Terbatas Kupon 10% OFF',
  rightsCenterBtn: 'Pusat Anggota',
  payBtn: 'Bayar',
  hasEqualRewardMuglo: 'Up to 1800 Diamonds BONUS from official website top-up!',
  productInterceptPopupTitle: 'Purchase Failed',
  productInterceptPopupTip: 'This item is not available in your region.<br>Please contact customer support if you have any questions.',
  productInterceptPopupConfirm: 'OK',
  vipHeadAwardText285 : 'Kemuliaan Agung (Permanen)',
  '-': '-'
};
